import AccordianTab from './AccordianTab';

export default AccordianTab;
